<template>
  <div>
    <div class="d-flex" style="gap: 16px">
      <v-text-field
        :value="localPromotion.name"
        dense
        outlined
        :disabled="!isEditing"
        :error-messages="errors.name ? [errors.name] : []"
        :label="$t('entities.promotions.card.promotionName')"
        class="flex-grow-1 promotion-card__text-field"
        @input="$emit('update-name', $event)" />
      <v-switch
        :input-value="localPromotion.active"
        inset
        dense
        hide-details
        :disabled="!isEditing"
        :label="$t('miscellaneous.active')"
        color="primary"
        class="active-switch"
        @change="$emit('update-active', $event)" />
    </div>
    <v-text-field
      :value="localPromotion.description"
      dense
      outlined
      :disabled="!isEditing"
      :error-messages="errors.description ? [errors.description] : []"
      :label="$t('generalAttributes.description')"
      class="promotion-card__text-field"
      @input="$emit('update-description', $event)" />
    <div class="d-flex" style="gap: 16px">
      <DiscountTypeToggle
        :options="viewOptions"
        :disabled="!isEditing"
        :value="localPromotion.discount_type"
        @input="$emit('discount-type-change', $event)" />
      <v-text-field
        :value="localPromotion.discount_value"
        dense
        outlined
        type="text"
        inputmode="decimal"
        hide-details="auto"
        required
        :disabled="!isEditing"
        :error-messages="errors.discount_value ? [errors.discount_value] : []"
        :label="discountLabel"
        class="flex-grow-1 promotion-card__text-field"
        @input="$emit('discount-input', $event)"
        @blur="$emit('discount-blur')">
        <template #append>
          <span class="promotion-card__discount-suffix pt-1">
            {{ discountSuffix }}
          </span>
        </template>
      </v-text-field>
    </div>
  </div>
</template>

<script>
import DiscountTypeToggle from './DiscountTypeToggle.vue'
import { isFixedPricePromotion } from '@/utils/promotions'

export default {
  name: 'PromotionCardFields',
  props: {
    localPromotion: { type: Object, required: true },
    arenaCurrency: { type: Object, default: () => ({}) },
    errors: { type: Object, default: () => ({}) },
    isEditing: { type: Boolean, default: false },
  },
  components: { DiscountTypeToggle },
  computed: {
    getCurrency() {
      return this.arenaCurrency?.symbol || this.arenaCurrency?.code || ''
    },
    isFixedPrice() {
      return isFixedPricePromotion(this.localPromotion)
    },
    discountLabel() {
      return this.isFixedPrice
        ? this.$t('entities.promotions.card.discountFixedPrice')
        : this.$t('entities.promotions.card.discountPercentage')
    },
    discountSuffix() {
      return this.isFixedPrice ? this.getCurrency : '%'
    },
    viewOptions() {
      return [
        {
          value: 'percentage',
          text: this.$t('entities.promotions.card.discountPct'),
        },
        {
          value: 'fixed_price',
          text: this.$t('entities.promotions.card.discountFixedPrice'),
        },
      ]
    },
  },
}
</script>

<style scoped>
.promotion-card__discount-suffix {
  font-size: 1rem;
  color: #4a4f63;
  padding-left: 0.25rem;
}

.promotion-card__text-field ::v-deep input {
  color: #000 !important;
}

.promotion-card__switch-label {
  font-size: 0.875rem;
  color: #4a4f63;
  user-select: none;
  margin-right: 0.25rem;
  flex-shrink: 0;
}

.active-switch {
  margin-top: 0.25rem;
  flex-shrink: 0;
}
</style>
